import { VoziqOffer, VoziqSaving } from '../voziq/types';

class VoziqService {
    private offers: ng.IPromise<VoziqOffer[]> | null = null;

    constructor(private Restangular: any) {
        'ngInject';
    }

    public getVoziqOffers(): ng.IPromise<VoziqOffer[]> {
        if (!this.offers) {
            this.offers = this.Restangular.one('voziq')
                .withHttpConfig({
                    cache: false
                }).get()
                .catch((error: any) => {
                    this.offers = null;
                    throw error;
                });
        }
        return this.offers;
    }

    public clearVoziqOffers() {
        this.offers = null;
    }

    public getSavings(): ng.IPromise<VoziqSaving[]> {
        return this.Restangular.one('voziq')
            .one('savings')
            .withHttpConfig({
                cache: false
            }).get();
    }

    public unlockSaving(voziqOfferId: number): ng.IPromise<VoziqSaving> {
        return this.Restangular.one('voziq', voziqOfferId)
            .one('unlock')
            .post();
    }
}

export default VoziqService;
